import { HeaderPage } from "../../../components/header-page/HeaderPage";

export const RoleHeader = () => {
  return <HeaderPage title="Roles" />;
};
